import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faPencil } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "@ts-digital/vrc/es/components/modal";
import RadioGroup from "@ts-digital/vrc/es/components/radio-group";
import Select from "@ts-digital/vrc/es/components/select";
import { useState } from "react";
import { useIntl } from "react-intl";
import { GainsightEvent, trackEvent } from "../../../core/common/gainsight";
import getFormattedMessageWithScope from "../../../utils/getFormattedMessageWithScope";
import { CustomButton } from "../CustomButton";
import { Locale, useLanguage } from "../LanguageProvider";
import { useWindowDimensions } from "../WindowDimensionsProvider";
import "./style.css";

const fm = getFormattedMessageWithScope("components.LanguageSelect");

export const LanguageSelect = () => {
    const intl = useIntl();
    const { width } = useWindowDimensions();
    const { setLanguage, locale } = useLanguage();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedLocale, setSelectedLocale] = useState(locale);

    function onChange(localeValue: string) {
        trackEvent(GainsightEvent.ChangeLanguage, { language: localeValue });
        setLanguage(localeValue);
    }

    function confirmLocale() {
        onChange(selectedLocale);
        setIsModalOpen(false);
    }

    return width >= 1000 ? (
        <Select
            value={locale}
            onChange={onChange}
            options={[
                {
                    description: intl.formatMessage({
                        id: "components.LanguageSelect.italian",
                    }),
                    value: Locale.ItIt,
                },
                {
                    description: intl.formatMessage({
                        id: "components.LanguageSelect.english",
                    }),
                    value: Locale.EnUs,
                },
            ]}
        />
    ) : (
        <>
            <div
                className="c-LanguageSelect-responsive"
                onClick={() => setIsModalOpen(true)}
            >
                <span className="c-LanguageSelect-responsive-language">
                    {fm(locale === Locale.EnUs ? "eng" : "ita")}
                </span>
                <FontAwesomeIcon
                    icon={faPencil as IconProp}
                    className="c-LanguageSelect-responsive-icon"
                />
            </div>
            <Modal
                className="c-LanguageSelect-responsive-Modal"
                visible={isModalOpen}
                title={
                    <span className="c-LanguageSelect-responsive-Modal-title">
                        {fm("modal.title")}
                    </span>
                }
                onClose={() => setIsModalOpen(false)}
                outsideClosable={false}
                closable={false}
                footer={
                    <div className="c-LanguageSelect-responsive-Modal-footer">
                        <div className="c-LanguageSelect-responsive-Modal-footer-buttons">
                            <CustomButton
                                kind="primary"
                                className="c-LanguageSelect-responsive-Modal-confirm-button"
                                onClick={confirmLocale}
                            >
                                {fm("modal.confirm")}
                            </CustomButton>
                        </div>
                    </div>
                }
            >
                <div className="c-LanguageSelect-responsive-Modal-content">
                    <RadioGroup
                        type="vertical"
                        value={selectedLocale}
                        onChange={(e: any) => setSelectedLocale(e.target.value)}
                        options={[
                            { label: fm("italian"), value: Locale.ItIt },
                            { label: fm("english"), value: Locale.EnUs },
                        ]}
                    />
                </div>
            </Modal>
        </>
    );
};
